export default function NotFoundPage({ navigate }: { navigate: (path: string) => void }) {
  return (
    <section className="page marketplace-page">
      <div className="marketplace-empty-state">
        <p className="marketplace-intro__eyebrow">AnTix</p>
        <h1>We couldn't find that page</h1>
        <p>The event or ticket link may be invalid or no longer available.</p>
        <button className="marketplace-link-button" type="button" onClick={() => navigate("/tickets")}>
          Browse Events
        </button>
      </div>
    </section>
  );
}
